import {
  createScenario,
  fetchAllScenarios,
  fetchScenarioById,
  archiveScenario,
  updateScenario,
  deleteScenario,
  activateScenario,
  deactivateScenario,
  openNodeExecutionAttendedListDrawer,
  closeNodeExecutionAttendedListDrawer,
  fetchNodeExecutionSummary,
  fetchNodeExecutionAttendedFailList,
  fetchNodeExecutionAttendedSkipList,
  dismissNodeExecutionUnattendedList,
  fetchNodeExecutionRejectedList,
  openNodeExecutionRejectedListDrawer,
  closeNodeExecutionRejectedListDrawer,
  duplicateScenario,
  openNodeExecutionCompletedListDrawer,
  closeNodeExecutionCompletedListDrawer,
  fetchNodeExecutionCompletedList,
  retryFailedNodeExecutions,
  resetSelectedScenario,
  fetchScenarioEmailServiceType,
  renameScenario,
} from '../../routines/scenarios/scenarioRoutines';
import {
  NODE_EXECUTION_SUMMARY_STATUS,
  SCENARIO_SCOPES,
} from '../../../common/constants/ScenarioConstants';

const initialState = {
  scenarioList: [],
  scenarioListLoading: false,
  scenarioListSuccess: false,
  selectedScenario: null,
  selectedScenarioLoading: false,
  selectedScenarioSuccess: false,
  scenarioCreating: false,
  scenarioCreateSuccess: false,
  scenarioUpdating: false,
  scenarioUpdateSuccess: false,
  scenarioArchiving: false,
  scenarioDeleting: false,
  scenarioActivating: false,
  scenarioDeactivating: false,
  scenarioExecutionAttendedListDrawerVisibility: false,
  scenarioExecutionRejectedListDrawerVisibility: false,
  scenarioNodeExecutionSummaryList: [],
  scenarioNodeExecutionSummaryLoading: false,
  scenarioNodeExecutionSummarySuccess: false,
  scenarioExecutionEntityAttendedFailList: [],
  scenarioExecutionEntityAttendedSkipList: [],
  scenarioExecutionEntityRejectedList: [],
  scenarioExecutionEntityAttendedFailListLoading: false,
  scenarioExecutionEntityAttendedSkipListLoading: false,
  scenarioExecutionUnattendedDismissLoading: false,
  scenarioExecutionUnattendedDismissSuccess: false,
  scenarioExecutionFailedRetryLoading: false,
  scenarioExecutionFailedRetrySuccess: false,
  scenarioExecutionRejectedListLoading: false,
  scenarioExecutionRejectedListSuccess: false,
  scenarioDuplicating: false,
  scenarioDuplicateSuccess: false,
  fetchingScenarioEmailType: false,
  scenarioEmailServiceType: null,
};

const scenarioReducer = (state = initialState, action) => {
  switch (action.type) {
    // fetch scenarios
    case fetchAllScenarios.TRIGGER:
      return {
        ...state,
        scenarioListSuccess: false,
        scenarioListLoading: true,
      };
    case fetchAllScenarios.SUCCESS:
      return {
        ...state,
        scenarioListLoading: false,
        scenarioListSuccess: true,
        scenarioList: action.payload?.data || [],
      };
    case fetchAllScenarios.FAILURE:
      return {
        ...state,
        scenarioListLoading: false,
        scenarioListSuccess: false,
      };

    // fetch scenario by ID
    case fetchScenarioById.TRIGGER:
      return {
        ...state,
        selectedScenarioLoading: true,
        selectedScenarioSuccess: false,
        selectedScenario: null,
      };
    case fetchScenarioById.SUCCESS:
      return {
        ...state,
        selectedScenarioLoading: false,
        selectedScenarioSuccess: true,
        selectedScenario: action.payload?.data || null,
      };
    case fetchScenarioById.FAILURE:
      return {
        ...state,
        selectedScenarioLoading: false,
        selectedScenarioSuccess: false,
      };

    // create scenario
    case createScenario.TRIGGER:
      return {
        ...state,
        scenarioCreateSuccess: false,
        scenarioCreating: true,
      };
    case createScenario.SUCCESS:
      return {
        ...state,
        scenarioCreateSuccess: true,
        scenarioCreating: false,
      };
    case createScenario.FAILURE:
      return {
        ...state,
        scenarioCreateSuccess: false,
        scenarioCreating: false,
      };

    // update scenario
    case updateScenario.TRIGGER:
      return {
        ...state,
        scenarioUpdateSuccess: false,
        scenarioUpdating: true,
      };
    case updateScenario.SUCCESS:
      return {
        ...state,
        scenarioUpdateSuccess: true,
        scenarioUpdating: false,
      };
    case updateScenario.FAILURE:
      return {
        ...state,
        scenarioUpdateSuccess: false,
        scenarioUpdating: false,
      };

    // archive Scenario
    case archiveScenario.TRIGGER:
      return {
        ...state,
        scenarioArchiving: true,
      };
    case archiveScenario.SUCCESS:
    case archiveScenario.FAILURE:
      return {
        ...state,
        scenarioArchiving: false,
      };

    // delete Scenario
    case deleteScenario.TRIGGER:
      return {
        ...state,
        scenarioDeleting: true,
      };
    case deleteScenario.SUCCESS:
    case deleteScenario.FAILURE:
      return {
        ...state,
        scenarioDeleting: false,
      };

    // activate scenario
    case activateScenario.TRIGGER:
      return {
        ...state,
        scenarioActivating: true,
      };
    case activateScenario.SUCCESS:
    case activateScenario.FAILURE:
      return {
        ...state,
        scenarioActivating: false,
      };

    // deactivate scenario
    case deactivateScenario.TRIGGER:
      return {
        ...state,
        scenarioDeactivating: true,
      };
    case deactivateScenario.SUCCESS:
    case deactivateScenario.FAILURE:
      return {
        ...state,
        scenarioDeactivating: false,
      };

    // open scenario node execution attended list drawer
    case openNodeExecutionAttendedListDrawer.TRIGGER: {
      return {
        ...state,
        scenarioExecutionAttendedListDrawerVisibility: true,
      };
    }

    // close scenario node execution attended list drawer
    case closeNodeExecutionAttendedListDrawer.TRIGGER:
      return {
        ...state,
        scenarioExecutionAttendedListDrawerVisibility: false,
      };

    // open scenario node execution rejected list drawer
    case openNodeExecutionRejectedListDrawer.TRIGGER: {
      return {
        ...state,
        scenarioExecutionRejectedListDrawerVisibility: true,
      };
    }

    // rename scenario
    case renameScenario.TRIGGER:
    case renameScenario.SUCCESS:
      return {
        ...state,
        ...(action.payload.scope === SCENARIO_SCOPES.LIST_VIEW && {
          selectedScenario: { ...state.scenarios?.selectedScenario },
        }),
      };

    // reset selected scenario
    case resetSelectedScenario.TRIGGER: {
      return {
        ...state,
        selectedScenario: null,
        selectedScenarioLoading: false,
        selectedScenarioSuccess: false,
      };
    }

    // close scenario node execution rejected list drawer
    case closeNodeExecutionRejectedListDrawer.TRIGGER:
      return {
        ...state,
        scenarioExecutionRejectedListDrawerVisibility: false,
      };

    // open scenario node execution completed list drawer
    case openNodeExecutionCompletedListDrawer.TRIGGER: {
      return {
        ...state,
        scenarioExecutionCompletedListDrawerVisibility: true,
      };
    }
    // close scenario node execution completed list drawer
    case closeNodeExecutionCompletedListDrawer.TRIGGER:
      return {
        ...state,
        scenarioExecutionCompletedListDrawerVisibility: false,
      };

    // fetch node execution unattended failure and skips
    case fetchNodeExecutionSummary.TRIGGER:
      return {
        ...state,
        scenarioNodeExecutionSummaryList: [],
        scenarioNodeExecutionSummaryLoading: true,
        scenarioNodeExecutionSummarySuccess: false,
      };
    case fetchNodeExecutionSummary.SUCCESS:
      return {
        ...state,
        scenarioNodeExecutionSummaryLoading: false,
        scenarioNodeExecutionSummarySuccess: true,
        scenarioNodeExecutionSummaryList: action.payload?.data || [],
      };
    case fetchNodeExecutionSummary.FAILURE:
      return {
        ...state,
        scenarioNodeExecutionSummaryLoading: false,
        scenarioNodeExecutionSummarySuccess: false,
      };

    case fetchNodeExecutionAttendedFailList.TRIGGER: {
      return {
        ...state,
        scenarioExecutionEntityAttendedFailList: [],
        scenarioExecutionEntityAttendedFailListLoading: true,
      };
    }
    case fetchNodeExecutionAttendedFailList.SUCCESS: {
      return {
        ...state,
        scenarioExecutionEntityAttendedFailListLoading: false,
        scenarioExecutionEntityAttendedFailList: action.payload?.data || [],
      };
    }
    case fetchNodeExecutionAttendedFailList.FAILURE: {
      return {
        ...state,
        scenarioExecutionEntityAttendedFailListLoading: false,
      };
    }

    case fetchNodeExecutionAttendedSkipList.TRIGGER: {
      return {
        ...state,
        scenarioExecutionEntityAttendedSkipList: [],
        scenarioExecutionEntityAttendedSkipListLoading: true,
      };
    }
    case fetchNodeExecutionAttendedSkipList.SUCCESS: {
      return {
        ...state,
        scenarioExecutionEntityAttendedSkipList: action.payload?.data || [],
        scenarioExecutionEntityAttendedSkipListLoading: false,
      };
    }
    case fetchNodeExecutionAttendedSkipList.FAILURE: {
      return {
        ...state,
        scenarioExecutionEntityAttendedSkipListLoading: false,
      };
    }

    case fetchNodeExecutionRejectedList.TRIGGER: {
      return {
        ...state,
        scenarioExecutionEntityRejectedList: [],
        scenarioExecutionRejectedListLoading: true,
      };
    }
    case fetchNodeExecutionRejectedList.SUCCESS: {
      return {
        ...state,
        scenarioExecutionEntityRejectedList: action.payload?.data || [],
        scenarioExecutionRejectedListLoading: false,
      };
    }
    case fetchNodeExecutionRejectedList.FAILURE: {
      return {
        ...state,
        scenarioExecutionRejectedListLoading: false,
      };
    }

    case fetchNodeExecutionCompletedList.TRIGGER: {
      return {
        ...state,
        scenarioExecutionEntityCompletedList: [],
        scenarioExecutionCompletedListLoading: true,
      };
    }
    case fetchNodeExecutionCompletedList.SUCCESS: {
      return {
        ...state,
        scenarioExecutionEntityCompletedList: action.payload?.data || [],
        scenarioExecutionCompletedListLoading: false,
      };
    }
    case fetchNodeExecutionCompletedList.FAILURE: {
      return {
        ...state,
        scenarioExecutionCompletedListLoading: false,
      };
    }

    case dismissNodeExecutionUnattendedList.TRIGGER: {
      return {
        ...state,
        scenarioExecutionUnattendedDismissLoading: true,
        scenarioExecutionUnattendedDismissSuccess: false,
      };
    }
    case dismissNodeExecutionUnattendedList.SUCCESS: {
      const { nodeId, status, dismissedLength } = action.payload;
      const selectedScenarioCopy = JSON.parse(
        JSON.stringify(state.selectedScenario)
      );
      selectedScenarioCopy.nodes.forEach((node) => {
        if (node.nodeId === nodeId) {
          node.executions.summary[NODE_EXECUTION_SUMMARY_STATUS[status]] -=
            dismissedLength;
        }
        return node;
      });
      return {
        ...state,
        selectedScenario: selectedScenarioCopy,
        scenarioExecutionUnattendedDismissLoading: false,
        scenarioExecutionUnattendedDismissSuccess: true,
      };
    }
    case dismissNodeExecutionUnattendedList.FAILURE: {
      return {
        ...state,
        scenarioExecutionUnattendedDismissLoading: false,
        scenarioExecutionUnattendedDismissSuccess: false,
      };
    }
    case retryFailedNodeExecutions.TRIGGER: {
      return {
        ...state,
        scenarioExecutionFailedRetryLoading: true,
        scenarioExecutionFailedRetrySuccess: false,
      };
    }
    case retryFailedNodeExecutions.SUCCESS: {
      return {
        ...state,
        scenarioExecutionFailedRetryLoading: false,
        scenarioExecutionFailedRetrySuccess: true,
      };
    }
    case retryFailedNodeExecutions.FAILURE: {
      return {
        ...state,
        scenarioExecutionFailedRetryLoading: false,
        scenarioExecutionFailedRetrySuccess: false,
      };
    }
    case duplicateScenario.TRIGGER: {
      return {
        ...state,
        scenarioDuplicating: true,
        scenarioDuplicateSuccess: false,
      };
    }
    case duplicateScenario.SUCCESS: {
      return {
        ...state,
        scenarioDuplicating: false,
        scenarioDuplicateSuccess: true,
      };
    }
    case duplicateScenario.FAILURE: {
      return {
        ...state,
        scenarioDuplicating: false,
        scenarioDuplicateSuccess: false,
      };
    }
    case fetchScenarioEmailServiceType.TRIGGER: {
      return {
        ...state,
        fetchingScenarioEmailType: true,
      };
    }
    case fetchScenarioEmailServiceType.SUCCESS: {
      return {
        ...state,
        fetchingScenarioEmailType: false,
        scenarioEmailServiceType: action.payload?.data.configValue,
      };
    }
    case fetchScenarioEmailServiceType.FAILURE: {
      return {
        ...state,
        fetchingScenarioEmailType: false,
      };
    }
    default:
      return state;
  }
};
export default scenarioReducer;
